import { render, staticRenderFns } from "./BrandsTable.vue?vue&type=template&id=8655cd48&scoped=true&"
import script from "./BrandsTable.vue?vue&type=script&lang=js&"
export * from "./BrandsTable.vue?vue&type=script&lang=js&"
import style0 from "./BrandsTable.vue?vue&type=style&index=0&id=8655cd48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655cd48",
  null
  
)

export default component.exports